import React, { createContext, useContext, useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import useAnalytics, { initGlobalClickTracking, hasAnalyticsConsent } from '../hooks/useAnalytics';

const AnalyticsContext = createContext(null);

export const useAnalyticsContext = () => {
  const context = useContext(AnalyticsContext);
  if (!context) {
    // Return no-op functions if not in provider
    return {
      trackEvent: () => {},
      trackClick: () => {},
      trackSubmit: () => {},
      trackCartEvent: () => {},
      trackPageView: () => {},
      hasConsent: false
    };
  }
  return context;
};

export const AnalyticsProvider = ({ children }) => {
  const analytics = useAnalytics();
  const initialized = useRef(false);

  useEffect(() => {
    if (!initialized.current && hasAnalyticsConsent()) {
      initGlobalClickTracking();
      initialized.current = true;
    }
  }, []);

  // Listen for consent changes
  useEffect(() => {
    const handleConsentGiven = () => {
      if (!initialized.current) {
        initGlobalClickTracking();
        initialized.current = true;
      }
    };

    window.addEventListener('analyticsConsentGiven', handleConsentGiven);
    return () => window.removeEventListener('analyticsConsentGiven', handleConsentGiven);
  }, []);

  return (
    <AnalyticsContext.Provider value={analytics}>
      {children}
    </AnalyticsContext.Provider>
  );
};

export default AnalyticsProvider;
